import { createSelector } from 'reselect';
// Import state types.
import {
	AppState,
	ClaimState,
} from '@app/redux/states';
// Import api models.
import {
	Peril,
	PolicyLoss
} from '@app/models/api';

// Fetches the producer signup state.
const getClaimState = (state: AppState): ClaimState => {
	return state.claim;
}

// Get claim perils selector.
const makeGetClaimPerilsSelector = () => createSelector(
	[getClaimState],
	(claimState: ClaimState | undefined): Peril[] => {
		return claimState !== undefined
			? claimState.perils
			: [];
	}
);

// Get current claim selector.
const makeGetCurrentClaimSelector = () => createSelector(
	[getClaimState],
	(claimState: ClaimState): PolicyLoss => {
		return claimState !== undefined
			? claimState.currentClaim
			: new PolicyLoss();
	}
);

// Get previous claims selector.
const makeGetPreviousClaimsSelector = () => createSelector(
	[getClaimState],
	(claimState: ClaimState): PolicyLoss[] => {
		return claimState !== undefined
			? claimState.previousClaims
			: [];
	}
);

// export selectors.
export {
	makeGetClaimPerilsSelector,
	makeGetCurrentClaimSelector,
	makeGetPreviousClaimsSelector,
};